import checkAjaxError from '@ott/helper-check-ajax-error';
import { actions as creditCardsActions } from '@ott/shared-credit-cards-logic';
import {
  actions as virtualCardActions,
  helpers as virtualCardHelpers,
} from '@ott/shared-virtual-card-logic';
import superagent from '@ott/superagent';
// @ts-ignore
import ieRequestTimestamp from '@ott/utility-ie-request-timestamp';

import { createAsyncThunk } from '@reduxjs/toolkit';

import addVirtualCardFlag from '../../helpers/addVirtualCardFlag';
import { AuthError, AuthData, SuperagentError } from '../../types';
import { Payload } from './types';

export const getBasicUserInfo = createAsyncThunk<
  AuthData,
  Payload | undefined,
  { rejectValue: AuthError }
>('auth/getInfo/fetch', async (args, { dispatch, rejectWithValue }) => {
  const { reqHost = '', withVirtualCard = true } = args ?? {};

  try {
    const {
      body: { result, error },
    } = await superagent
      .get(`${reqHost}/_auth/profile/getBasicUserInfo`)
      .query(ieRequestTimestamp())
      .withCredentials();

    if (result.cards) {
      try {
        const cards = addVirtualCardFlag(result.cards);

        // метод не поддержан на onetwotrip.kz
        const isKZ = window.location.hostname.includes('.kz');
        const hasVirtualCard = virtualCardHelpers.hasVirtualCard(cards);

        if (!isKZ && hasVirtualCard && withVirtualCard) {
          await dispatch(virtualCardActions.getCardInfo());
        }
        await dispatch(creditCardsActions.saveCards(cards));
      } catch (err) {
        console.error(err);
        // @ts-ignore
        if (global.trackJs) {
          // @ts-ignore
          global.trackJs.track('getBasicUserInfo saveCards error:', err);
        }
      }
    }

    if (error) {
      return rejectWithValue({ data: error });
    }

    if (result.redirect) {
      window.location = result.redirect;
    }

    return result as AuthData;
  } catch (e) {
    const err = e as SuperagentError;
    if (err && err?.status === 401) {
      return rejectWithValue({ status: err.status, data: err.response.body.error });
    }

    return rejectWithValue({ data: checkAjaxError(e) });
  }
});
